(() => {
  const sections = [...document.querySelectorAll("[data-griffe-study]")];
  if (!sections.length) return;

  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  let scrollFrame = 0;
  let navigationFrame = 0;
  let pointerFrame = 0;
  let pointerX = 0;
  let pointerY = 0;
  let currentX = 0;
  let currentY = 0;

  const clamp = (value) => Math.max(0, Math.min(1, value));
  const pageTop = (element) => window.scrollY + element.getBoundingClientRect().top;

  const animateScroll = (target, hash, duration = 1150) => {
    window.cancelAnimationFrame(scrollFrame);
    const start = window.scrollY;
    const distance = target - start;
    const actualDuration = reduceMotion.matches ? 0 : duration;

    if (!actualDuration || Math.abs(distance) < 2) {
      window.scrollTo({ top: target, left: 0, behavior: "instant" });
      window.history.replaceState(null, "", hash);
      return;
    }

    const startedAt = performance.now();
    const step = (now) => {
      const linear = clamp((now - startedAt) / actualDuration);
      const eased = 1 - Math.pow(1 - linear, 4);
      window.scrollTo({ top: start + distance * eased, left: 0, behavior: "instant" });
      if (linear < 1) {
        scrollFrame = requestAnimationFrame(step);
      } else {
        scrollFrame = 0;
        window.history.replaceState(null, "", hash);
      }
    };
    scrollFrame = requestAnimationFrame(step);
  };

  document.querySelectorAll("[data-study-link]").forEach((link) => {
    link.addEventListener("click", (event) => {
      const hash = link.getAttribute("href");
      const target = hash && document.querySelector(hash);
      if (!target) return;
      event.preventDefault();
      animateScroll(pageTop(target), hash);
    });
  });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const section = entry.target;
      section.classList.add("is-visible");
      window.setTimeout(() => section.querySelector(".gj-range-art")?.classList.add("is-settled"), reduceMotion.matches ? 0 : 2100);
      observer.unobserve(section);
    });
  }, { threshold: 0.2 });

  sections.forEach((section) => observer.observe(section));

  const updateNavigationState = () => {
    navigationFrame = 0;
    const center = window.innerHeight * 0.5;
    sections.forEach((section) => {
      const rect = section.getBoundingClientRect();
      const isActive = rect.top <= center && rect.bottom > center;
      section.classList.toggle("is-section-active", isActive);
      section.querySelectorAll(".gj-ranges__back, .gj-study__next").forEach((link) => {
        link.setAttribute("aria-hidden", String(!isActive));
        link.tabIndex = isActive ? 0 : -1;
      });
    });
  };

  const requestNavigationUpdate = () => {
    if (!navigationFrame) navigationFrame = requestAnimationFrame(updateNavigationState);
  };

  const updatePointer = () => {
    currentX += (pointerX - currentX) * 0.085;
    currentY += (pointerY - currentY) * 0.085;
    sections.forEach((section) => {
      section.style.setProperty("--gj-range-pointer-x", currentX.toFixed(3));
      section.style.setProperty("--gj-range-pointer-y", currentY.toFixed(3));
    });
    if (Math.abs(pointerX - currentX) > 0.002 || Math.abs(pointerY - currentY) > 0.002) {
      pointerFrame = requestAnimationFrame(updatePointer);
    } else {
      pointerFrame = 0;
    }
  };

  document.addEventListener("pointermove", (event) => {
    if (reduceMotion.matches || window.innerWidth <= 760) return;
    pointerX = clamp(event.clientX / window.innerWidth) * 2 - 1;
    pointerY = clamp(event.clientY / window.innerHeight) * 2 - 1;
    if (!pointerFrame) pointerFrame = requestAnimationFrame(updatePointer);
  }, { passive: true });

  window.addEventListener("scroll", requestNavigationUpdate, { passive: true });
  window.addEventListener("resize", requestNavigationUpdate, { passive: true });
  updateNavigationState();
})();
